exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nces-search-input-component .suggestion-wrapper {\n  position: relative; }\n  .nces-search-input-component .suggestion-wrapper .list-group {\n    position: absolute;\n    z-index: 1;\n    width: 100%; }\n    .nces-search-input-component .suggestion-wrapper .list-group .list-group-item.active {\n      background: #0E4C60;\n      color: white; }\n\n.nces-search-input-component .optional-text {\n  font-size: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/nces-search-input.sass
// module id = 850
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91